import { API_URL } from '../utils/constants/api';
import axios from 'axios';
import { getAccessToken } from 'utils/helpers/localStorage';

const makeHeaders = () => {
  let access_token = getAccessToken();
  if (access_token !== null)
    return {
      'Content-Type': 'application/json',
      'ACCESS-TOKEN': access_token,
    };
  else
    return {
      'Content-Type': 'application/json',
    };
};

const client = () => {
  return axios.create({
    baseURL: API_URL,
    headers: makeHeaders(),
  });
};

export { client };
